import { PushNotification } from '../../graphql/generated';

export type NotificationHandler = (notification: PushNotification) => void;

export type NotificationType = 'SUCCESS' | 'INFO' | 'ERROR' | 'WARNING' | 'PROMOTION';

export enum NotificationTopic {
  SAVE_TIMESHEET = 'SAVE_TIMESHEET',
  SUBMIT_TIMESHEET = 'SUBMIT_TIMESHEET',
  ALL_NOTIFICATIONS = 'ALL_NOTIFICATIONS',
}

class NotificationHandlerService {
  private handlers = new Map<string, NotificationHandler[]>();

  public addHandler(topic: NotificationTopic, handler: NotificationHandler): void {
    const notificationHandlers = this.handlers.get(topic) || [];

    notificationHandlers.push(handler);
    this.handlers.set(topic, notificationHandlers);

    if (topic !== NotificationTopic.ALL_NOTIFICATIONS) {
      this.addHandler(NotificationTopic.ALL_NOTIFICATIONS, handler);
    }
  }

  public removeHandler(topic: NotificationTopic, handler: NotificationHandler): void {
    const notificationHandlers = this.handlers.get(topic);
    if (notificationHandlers) {
      const index = notificationHandlers.indexOf(handler);
      if (index !== -1) {
        notificationHandlers.splice(index, 1);
        this.removeHandler(NotificationTopic.ALL_NOTIFICATIONS, handler);
      }
    }
  }

  public handleNotification(notification: PushNotification): void {
    const { topic } = notification;

    const notificationHandlers = this.handlers.get(topic) || [];
    const allNotificationHandlers = this.handlers.get(NotificationTopic.ALL_NOTIFICATIONS) || [];

    const handlers = [...notificationHandlers, ...allNotificationHandlers];

    handlers.forEach((handler) => handler(notification));
  }

  public hasHandlers(topic: NotificationTopic): boolean {
    const notificationHandlers = this.handlers.get(topic);

    return !!notificationHandlers && notificationHandlers.length > 0;
  }
}

export default NotificationHandlerService;
